import {Directive, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';

@Directive({
  selector: '[appDropzone]'
})
export class DropzoneDirective {
  @Output() focus = new EventEmitter();
  @Output() unfocus = new EventEmitter();
  @Output() dropElem = new EventEmitter();
  @Input() isRoot = false;
  @Input() focusSecondary = false;
  @Input() disableDropZone = false;
  private stateFocus: boolean;

  constructor(private element: ElementRef) {}

  @HostListener('dragover', ['$event'])
  private onDragEnter(evt: any) {
    if (this.disableDropZone) {
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();

    if (!(this.isRoot && this.focusSecondary)) {
      this.element.nativeElement.classList.add('dragIn');
    }
    this.stateFocus = true;
    this.focus.emit();
  }

  @HostListener('dragleave', ['$event'])
  private onDragLeave(evt) {
    if (this.disableDropZone) {
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();

    this.element.nativeElement.classList.remove('dragIn');
    this.stateFocus = false;
    this.unfocus.emit();
  }

  @HostListener('drop', ['$event'])
  public onDrop(evt: any) {
    if (this.disableDropZone) {
      return;
    }
    this.onDragLeave(evt);

    const files = evt.dataTransfer;

    this.dropElem.emit(files);
  }
}
